<mat-card class="page-card">
  <section class="page-header">
    <div class="page-header-content">
      <div class="page-header-icon">
        <mat-icon>admin_panel_settings</mat-icon>
      </div>
      <div class="page-header-text">
        <span class="eyebrow">{{ 'organizationAdmin.banner.eyebrow' | transloco }}</span>
        <h1>{{ 'organizationAdmin.banner.title' | transloco }}</h1>
        <p>{{ 'organizationAdmin.banner.description' | transloco }}</p>
      </div>
    </div>
  </section>

  <nav mat-tab-nav-bar [tabPanel]="tabPanel" [mat-stretch-tabs]="false" mat-align-tabs="start">
    <a mat-tab-link disableRipple [routerLink]="organizationPath" routerLinkActive #organizationLink="routerLinkActive" [active]="organizationLink.isActive">
      {{ 'organizationAdmin.tabs.organization' | transloco }}
    </a>
    <a mat-tab-link disableRipple [routerLink]="usersPath" routerLinkActive #usersLink="routerLinkActive" [active]="usersLink.isActive">
      {{ 'organizationAdmin.tabs.users' | transloco }}
    </a>
    <a mat-tab-link disableRipple [routerLink]="groupsPath" routerLinkActive #groupsLink="routerLinkActive" [active]="groupsLink.isActive">
      {{ 'organizationAdmin.tabs.groups' | transloco }}
    </a>  </nav>
  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</mat-card>
